// extracted by mini-css-extract-plugin
export default {"textArea":"DoNotCallDialog_textArea__fRf4d","doNotCallDescription":"DoNotCallDialog_doNotCallDescription__92XpR","toggleHolder":"DoNotCallDialog_toggleHolder__96pHN"};